export const ServiceInitialData = {
  serviceName: "",
  serviceType: 0,
  dirname: "manageServices",
  menuCategoryID: 0,
  serviceDescription: "",
  isThisHomeService: 0,
  isThisComboService: 0,
  comboServiceIds: 0,
  ID: 0,
  Pricingandduration: [
    {
      Duration: 0,
      Pricetype: 0,
      Price: 0,
      PricinganddurationID: 0,
    },
  ],
  Team: [
    {
      Name: "",
      Ischecked: true,
      ID: 0,
      serviceTeamID: 0,
    },
  ],
};
